/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Placeholder_TitleInputs */

const en_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const de_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const fr_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const es_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const it_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const nl_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const pl_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const fi_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const da_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

const sv_story_bank_placeholder_title = /** @type {(inputs: Story_Bank_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Led cross-functional migration project`)
};

/**
* | output |
* | --- |
* | "e.g., Led cross-functional migration project" |
*
* @param {Story_Bank_Placeholder_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_placeholder_title = /** @type {((inputs?: Story_Bank_Placeholder_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Placeholder_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_placeholder_title(inputs)
	if (locale === "fr") return fr_story_bank_placeholder_title(inputs)
	if (locale === "es") return es_story_bank_placeholder_title(inputs)
	if (locale === "it") return it_story_bank_placeholder_title(inputs)
	if (locale === "nl") return nl_story_bank_placeholder_title(inputs)
	if (locale === "pl") return pl_story_bank_placeholder_title(inputs)
	if (locale === "fi") return fi_story_bank_placeholder_title(inputs)
	if (locale === "da") return da_story_bank_placeholder_title(inputs)
	if (locale === "sv") return sv_story_bank_placeholder_title(inputs)
	return en_story_bank_placeholder_title(inputs)
});